export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-geo/src/constant.js
// module id = ../../../../d3-geo/src/constant.js
// module chunks = vendor